import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

const Label = (props) => {
    const { children, ...labelProps } = props;
    return <label { ...labelProps }>{ children }</label>
}

Label.propTypes = {
    'children': PropTypes.any.isRequired
};

export default Label;



// WEBPACK FOOTER //
// ./src/components/gdc-components-atoms-label/index.jsx